import dateIsValid from './dateIsValid';

/**
 * Returns Date from moment
 *
 * @param {moment.Moment|null} date
 * @return {Date|null}
 */
const getDate = date => (dateIsValid(date) ? date.toDate() : null);

export default getDate;
